import { render, staticRenderFns } from "./PieChartWidget.vue?vue&type=template&id=c22b7a68&scoped=true&"
import script from "./PieChartWidget.vue?vue&type=script&lang=js&"
export * from "./PieChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22b7a68",
  null
  
)

export default component.exports